<template>
  <div>
    <div class="bio-bg-image">
        <img src="https://firebasestorage.googleapis.com/v0/b/hiddenvillagecreations-51e08.appspot.com/o/hvc_work_station.png?alt=media">
        <div class="bg-text-intro is-hidden-touch" id="top_intro">
            <p class="title is-1 has-text-white">Hidden Village Creations</p>
            <p class="subtitle is-4 has-text-white">Borosilicate glass worker based out of Kelowna, BC</p>
        </div>

        <div class="is-hidden-desktop bg-text-intro-mobile" id="top_intro">
            <p class="title is-4 has-text-white">Hidden Village Creations</p>
            <p class="subtitle is-6 has-text-white">Borosilicate glass worker based out of Kelowna, BC</p>
        </div>
     
    </div>

    <div class="bio-bg-image" id="about">
        <img src="https://firebasestorage.googleapis.com/v0/b/hiddenvillagecreations-51e08.appspot.com/o/hvc_work_station_4.png?alt=media">
        <div class="bg-text-bio is-hidden-touch">
            <p class="title is-1 has-text-white">Mike Astral</p>
            <p class="subtitle is-4 has-text-white">I'm a 10+ years experienced glassblower that has produced thousands of functional and non-functional glass art pieces.
            <br>Hidden Village Creations has been focusing on functional glass art and has gained a good reputation in Smoke and Novelty shops across Canada.</p>
        </div>

        <div class="bg-text-bio-mobile is-hidden-desktop">
            <p class="title is-4 has-text-white">Mike Astral</p>
            <p class="subtitle is-6 has-text-white">I'm a 10+ years experienced glassblower that has produced thousands of functional and non-functional glass art pieces.
            <br>Hidden Village Creations has been focusing on functional glass art and has gained a good reputation in Smoke and Novelty shops across Canada.</p>
        </div>
    </div>

    <div class="bio-bg-image">
        <img src="https://firebasestorage.googleapis.com/v0/b/hiddenvillagecreations-51e08.appspot.com/o/hvc_work_station_2.png?alt=media">
        <div class="bg-text-feature">
        <div class="container">
          <div class="columns is-gapless">
            <div class="column is-hidden-touch">
                <iframe width="512" height="288" src="https://www.youtube-nocookie.com/embed/f2sdF-cHVM0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
            <div class="column">
                <div class="is-hidden-touch">
                    <p class="title is-1 has-text-white">My Specialty</p>
                    <p class="subtitle is-4 has-text-white">I love fuming work and especially specialized in gold fuming. I'm a gold miner and I use the gold I found in the projects that I make.
                    <br>Are you curious about what the magic is behind the fuming? Come check out my <a href="https://www.youtube.com/watch?v=f2sdF-cHVM0&ab_channel=TheGoldPanner" target="_blank" style="color:#0ABAB5;">Youtube</a> videos!</p>
                </div>

                <div class="is-hidden-desktop">
                    <p class="title is-4 has-text-white">My Specialty</p>
                    <p class="subtitle is-6 has-text-white">I love fuming work and especially specialized in gold fuming. I'm a gold miner and I use the gold I found in the projects that I make.
                    <br>Are you curious about what the magic is behind the fuming? Come check out my <a href="https://www.youtube.com/watch?v=f2sdF-cHVM0&ab_channel=TheGoldPanner" target="_blank"><strong style="color:#0ABAB5;">Youtube</strong></a> videos!</p>
                </div>
            </div>
          </div>
          <div class="columns is-hidden-mobile">
            <div class="column fume_img"><img src="https://firebasestorage.googleapis.com/v0/b/hiddenvillagecreations-51e08.appspot.com/o/277163211_10166046273835363_7037841441917566544_n.jpeg?alt=media" /></div>
            <div class="column fume_img"><img src="https://firebasestorage.googleapis.com/v0/b/hiddenvillagecreations-51e08.appspot.com/o/292286509_10166346080800363_2333597759700957780_n.jpeg?alt=media" /></div>
            <div class="column fume_img"><img src="https://firebasestorage.googleapis.com/v0/b/hiddenvillagecreations-51e08.appspot.com/o/294680229_10166377537645363_3360161921872508659_n.jpeg?alt=media" /></div>
            <div class="column fume_img"><img src="https://firebasestorage.googleapis.com/v0/b/hiddenvillagecreations-51e08.appspot.com/o/294755291_10166377561660363_2822515847616463596_n.jpeg?alt=media" /></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'about'
}

document.addEventListener('DOMContentLoaded', () => {
  // Get all "navbar-burger" elements
  const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

  // Check if there are any navbar burgers
  if ($navbarBurgers.length > 0) {
    // Add a click event on each of them
    $navbarBurgers.forEach( el => {
      el.addEventListener('click', () => {

        // Get the target from the "data-target" attribute
        const target = el.dataset.target;
        const $target = document.getElementById(target);

        // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
        el.classList.toggle('is-active');
        $target.classList.toggle('is-active');

      });
    });
  }

//   window.addEventListener('scroll', function(){
//     // console.log(scrollY)

//     if ("ontouchstart" in document.documentElement) {
//         // content for touch-screen (mobile) devices
//         // everything else (desktop)
//         if (scrollY >= 0 && scrollY <= 300) {
//             document.getElementById('top_intro').style.visibility = 'visible';
//         } else {
//             document.getElementById('top_intro').style.visibility = 'hidden';
//         }

//     } else {
//         // everything else (desktop)
//         if (scrollY >= 0 && scrollY <= 1200) {
//             document.getElementById('top_intro').style.visibility = 'visible';
//         } else {
//             document.getElementById('top_intro').style.visibility = 'hidden';
//         }
//     }
//   });

});

</script>

<style>
.bg-image {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.bg-text-intro {
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0, 0.4); /* Black w/opacity/see-through */
  color: white;
  font-weight: bold;
  border: 10px solid #f1f1f1;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  padding: 20px;
  text-align: center;
}

.bg-text-intro-mobile {
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0, 0.4); /* Black w/opacity/see-through */
  color: white;
  font-weight: bold;
  border: 5px solid #f1f1f1;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  padding: 5px;
  text-align: center;
  width: 80%;
}

.bio-bg-image {
  position: relative;
  text-align: center;
  margin: -8px;
}

.bg-text-bio {
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0, 0.5); /* Black w/opacity/see-through */
  color: white;
  font-weight: bold;
  border: 10px solid #0ABAB5;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  padding: 20px;
  text-align: center;
}

.bg-text-bio-mobile {
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0, 0.5); /* Black w/opacity/see-through */
  color: white;
  font-weight: bold;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  padding: 20px;
  text-align: center;
  width: 100%
}

.bg-text-feature {
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0, 0.5); /* Black w/opacity/see-through */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  z-index: 2;
  padding: 20px;
}

.fume_img {
  height: 220px;
  width: 220px;
  overflow: hidden;
}

.fume_img img{
  width: 100%;
  height: auto;
  position: relative;
  top: 50%;
  -webkit-transform: translateY(-50%); /* Ch <36, Saf 5.1+, iOS < 9.2, An =<4.4.4 */
  -ms-transform: translateY(-50%); /* IE 9 */
  transform: translateY(-50%); /* IE 10, Fx 16+, Op 12.1+ */
}
</style>
